const directives = require.context("./", true, /index.js$/);

export default (Vue) => {
  directives.keys().map((item) => {
    const name = item.replace(/^\.\//, "").replace(/\/index\.\w+$/, "");
    Vue.directive(name, directives(item).default);
  });
};
